<template>
  <b-card no-body class="p-2">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-2">
      <b-card-title class="mb-0">
        <span class="fs-4">Tren Media Sosial</span>
      </b-card-title>
    </div>

    <!-- Chart -->
    <loader v-if="loading" />
    <lineChart v-else-if="chartData && chartData.series && chartData.series.length > 0" :data="chartData" />
    <div v-else class="text-center py-5">
      <p class="text-muted">Tidak ada data trend.</p>
    </div>
  </b-card>
</template>

<script>
import loader from "@/views/components/loader.vue";
import lineChart from "@/views/components/lineChart.vue";
import { BCard, BCardTitle } from "bootstrap-vue";

export default {
  name: "SmdTrendChart",
  components: { loader, lineChart, BCard, BCardTitle },
  props: {
    loading: { type: Boolean, default: false },
    data: { type: Object, default: () => ({}) },
  },
  computed: {
    chartData() {
      if (!this.data || !this.data.categories) return {};
      return {
        type: "area",
        categories: this.data.categories,
        series: this.data.series,
        colors: ["#1877F2", "#E4405F"], // Facebook Blue, Instagram Pink
        strokeWidth: [3, 3],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.4,
            opacityTo: 0.05,
            stops: [0, 90, 100]
          }
        },
        yaxisTitle: {
          text: "Jumlah Data",
          offsetX: 6,
          style: {
            color: "#A9A9A9",
            fontSize: "12px",
            fontFamily: "Montserrat",
            fontWeight: 600,
          }
        },
        markers: { 
          size: 0,
          hover: { size: 6 }
        },
        tooltip: { theme: "dark" },
        legend: { show: true },
      };
    }
  }
};
</script>
